import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initAnalytics } from "./utils/analytics";
import { applySeo } from "./utils/seo";
applySeo();
initAnalytics();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-188" data-mp="26abycpiqc4r9" />);
}